// @ts-ignore
export const NetDania = window.NetDania
export const config = {
  containerId: 'ChartContainerIndex',
  host: '//balancer.netdania.com/StreamingServer/StreamingServer',
  failoverHosts: [
    '//balancer-cro.netdania.com/StreamingServer/StreamingServer',
    '//balancer.datafeeds.io/StreamingServer/StreamingServer',
    '//balancer-cro.datafeeds.io/StreamingServer/StreamingServer',
  ],
  locale: {
    host: '//balancer.netdania.com/js/nfsc/pro-patterns/v2.2.2/assets/locales/',
    failoverHosts: [
      '//balancer-cro.netdania.com/js/nfsc/pro-patterns/v2.2.2/assets/locales/',
      '//balancer.datafeeds.io/js/nfsc/pro-patterns/v2.2.2/assets/locales/',
      '//balancer-cro.datafeeds.io/js/nfsc/pro-patterns/v2.2.2/assets/locales/',
    ],
  },
  behavior: NetDania.JsApi.ConnectionType.AUTO,
  pollingInterval: NetDania.JsApi.PoolingInterval.AUTO,
  livePoints: 9,
  historicalPoints: 0,
  displayPoints: 9,
  initialRightGap: 0,
  offsetGridLinesX: false,
  autoBarFit: false,
  defaultTheme: 'black',
  defaultChartType: 'candleStick',
  defaultLanguage: 'en',
  panOnFullWindow: false,
  showTopToolbar: false,
  templateMode: 1,
  legend: {
    enabled: false,
  },
  scales: {
    xAxis: {
      visible: false,
      showFastForward: false,
    },
    yAxis: {
      visible: false,
      verticalLock: true,
      gridLinesPadding: 20,
    },
    instrument: {
      showCurrentValueLine: true,
      showCurrentValueLabel: false,
      showLastValueLine: false,
      showLastValueLabel: false,
    },
    study: {
      showCurrentValueLine: false,
      showCurrentValueLabel: false,
      showLastValueLine: false,
      showLastValueLabel: false,
    },
  },
  defaultTimeScale: 3600,
  defaultInstrument: {
    symbol: 'EURUSD',
    provider: 'netdania_fxa',
  },
  tooltip: {
    enabled: false,
  },
  context: {
    enabled: false,
  },
  xScaleFormats: {
    2: {
      First: 'HHmmss',
      OHLCV: 'MMM D YYYY HHmm',
    },
  },
  menus: {
    toggleToolbarOpts: false,
    instruments: {},
  },
}

interface Instrument {
  instr: string
}

export function createRequestIdToInstrumentMap(
  myLine1,
): { [requestId: string]: Instrument } {
  const filter = myLine1.chartApi.requests
  const map = {}
  for (const filterElement of filter) {
    filterElement.requests.forEach(r => {
      map[r.requestId] = r.instrument
    })
  }
  return map
}
